import { ContentLayout, CustomeDialog, CustomTable, LoadingButton } from "../../../shared";
import * as React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { sortItems } from "../../../utils";
import SimpleReactValidator from "simple-react-validator";
import InputControl from "../../../shared/components/InputControl";
import { useStripeConnect } from "../hooks";

export const StripeConnectList = () => {
  const {
    state,
    isEditable,
    handleTableSearch,
    handleStatusFilter,
    resetFilter,
    handleModal,
    handleStoreConnect,
  } = useStripeConnect();

  const {
    isLoading,
    dataList,
    filter,
    isOpenConnect,
    selectedStore,
    isSaveButton,
  } = state;
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const ActionButtons = ({ value, id }) => {
    return (
      <div className="action-buttons">
        {value.stripe_account_id && (
          <Typography variant="caption" color="#636363">
            Stripe ID: {value.stripe_account_id}
          </Typography>
        )}
        {isEditable && (
          <>
            {!value.stripe_connect_status ? (
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleModal("connect", true, value)}
              >
                Connect
              </Button>
            ) : (
              <Button
                variant="outlined"
                size="small"
                color="error"
                onClick={() => handleModal("connect", true, value)}
              >
                Disconnect
              </Button>
            )}
          </>
        )}
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Store",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },

      {
        Header: "Action",
        id: "id",
        accessor: "id",
        align: "right",
        disableSortBy: true,
        Cell: ({ row }) => {
          return <ActionButtons value={row.original} id={row.original.id} />;
        },
      },
    ],
    []
  );

  const statusOption = [
    { value: "1", label: "Connected" },
    { value: "0", label: "Disconnected" },
  ];

  const tandaList = [
    {
      id: 1,
      store: "Store 1",
      status: "1",
    },
    {
      id: 2,
      store: "Store 2",
      status: "0",
    },
  ];

  return (
    <>
      <ContentLayout title="Stripe Connect">
        <CustomTable
          columns={columns}
          data={dataList}
          isLoading={isLoading}
          searchBar={true}
          defaultSearch={false}
          filterContent={
            <>
              <InputControl
                type="table-search"
                name="search"
                placeholder="Search store..."
                onChange={handleTableSearch}
                value={filter.searchText}
                onClear={() => handleTableSearch({ target: { value: "" } })}
              />
              <InputControl
                type="select"
                name="status"
                label="Connection Status"
                optionValue={statusOption}
                width="260px"
                onChange={(e) => handleStatusFilter(e)}
                value={filter?.status || ""}
              />
              <Button
                type="button"
                size="medium"
                variant="text"
                color="gray"
                sx={{
                  minWidth: "40px",
                  p: "8px",
                }}
                onClick={() => resetFilter()}
              >
                <img alt="close" src="/icons/ic_close.svg" />
              </Button>
            </>
          }
        />
      </ContentLayout>

      <CustomeDialog
        open={isOpenConnect}
        handleClose={() => handleModal("connect", false, null)}
        PaperProps={{
          sx: { width: "423px", height: "155px", p: "16px" },
        }}
        title={`${
          selectedStore?.stripe_connect_status == "1" ? "Disconnect" : "Connect"
        } Stripe`}
        content={
          <Stack
            mt="8px"
            gap="10px"
            height="100%"
            justifyContent="space-between"
          >
            <Typography variant="subtitle2">
              Are you sure you want to{" "}
              {selectedStore?.stripe_connect_status == "1"
                ? "disconnect"
                : "connect"}{" "}
              Stripe for {selectedStore?.name}?
            </Typography>
            <Stack direction="row" justifyContent="end" gap={2}>
              <Button
                variant="text"
                onClick={() => handleModal("connect", false, null)}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={isSaveButton}
                variant="contained"
                color={
                  selectedStore?.stripe_connect_status == "1"
                    ? "error"
                    : "primary"
                }
                onClick={() => handleStoreConnect(selectedStore)}
              >
                {selectedStore?.stripe_connect_status == "1"
                  ? "Disconnect"
                  : "Connect"}
              </LoadingButton>
            </Stack>
          </Stack>
        }
      />
    </>
  );
};
